export default "__VITE_ASSET__43dc431b__"